import { Address } from "viem";

import { type Environment, environment } from "../environment";

export enum ChainId {
  ARBITRUM = 42161,
  ARBITRUM_SEPOLIA = 421614,
}

export const isMainnet = process.env.NEXT_PUBLIC_NETWORK_MODE === "mainnet";

export const mainnetChainIds = [ChainId.ARBITRUM];
export const testnetChainIds = [ChainId.ARBITRUM_SEPOLIA];

export enum BridgeChainId {
  ETHEREUM = 1,
  OPTIMISM = 10,
  BSC = 56,
  BASE = 8453,
  ARBITRUM = 42161,
}

const clearingHouseProxyMap: Record<Environment, Record<ChainId, Address>> = {
  development: {
    [ChainId.ARBITRUM]: "0x9AdCbEd09f911060Ef36570dC411196A86Ffb644",
    [ChainId.ARBITRUM_SEPOLIA]: "0x1fd07c1c676023b15d9df537d147dcc68bfb84c6",
  },
  sandbox: {
    [ChainId.ARBITRUM]: "0x9AdCbEd09f911060Ef36570dC411196A86Ffb644",
    [ChainId.ARBITRUM_SEPOLIA]: "0x1fd07c1c676023b15d9df537d147dcc68bfb84c6",
  },
  staging: {
    [ChainId.ARBITRUM]: "0x9AdCbEd09f911060Ef36570dC411196A86Ffb644",
    [ChainId.ARBITRUM_SEPOLIA]: "0x1fd07c1c676023b15d9df537d147dcc68bfb84c6",
  },
  production: {
    [ChainId.ARBITRUM]: "0x9AdCbEd09f911060Ef36570dC411196A86Ffb644",
    [ChainId.ARBITRUM_SEPOLIA]: "0x746ee6b2689d56d9d593bc1bb733b48bfd4908d0", // TC contract
  },
};

export const clearingHouseProxy = clearingHouseProxyMap[environment];

export const UNISWAP_PERMIT2 = "0x000000000022D473030F116dDEE9F6B43aC78BA3";
